// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"bba8de88","256":"31c7f8d1","308":"a231fc12","453":"9f9083ed","577":"f58b5205","588":"f9ce1e48","647":"4c493a4a","751":"010b5c16"}[chunkId] + ".chunk.js";
};